import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { InfoStoreModule } from '@wonder-core-ng/info-store/info-store.module';
import { AuthHttpInterceptor } from '@wonder-core-ng/session-store/auth-http.interceptor.service';
import { AIEffects } from './ai.effects';
import * as fromAI from './ai.reducer';
import { AIService } from './ai.service';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(fromAI.aiFeatureKey, fromAI.reducer),
    EffectsModule.forFeature([AIEffects]),
    InfoStoreModule,
  ],
  // AIApiService is provided in root (see its class comment).
  providers: [
    AIService,
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthHttpInterceptor,
      multi: true,
    },
  ],
})
export class AIStoreModule {}
